import { ReactNode } from 'react'
import Step from './DashboardBuilderStep'
import AsyncSelect from 'Shared/components/AsyncSelect'
import { useAct } from 'DashboardBuilder/store'

// eslint-disable-next-line react/prop-types
function UsersShortDescriptor({
  dashboardScope,
  groups,
}: {
  dashboardScope: ReactNode
  groups: {
    name: string
  }[]
}) {
  const groupNames = groups.map((g) => g.name).join(', ')
  return groups.length === 0 ? (
    <p className="no-margin-bottom">
      Currently no one can view this Dashboard. Add one or more user groups to grant access.
    </p>
  ) : (
    <p>
      Anyone within the user groups <span className="bold">{groupNames}</span>, who is
      within <span className="bold">{dashboardScope}</span> or any sub-organisation, can
      view this dashboard.
    </p>
  )
}

function GroupsList({ groups }) {
  const act = useAct()

  return  <>
    {groups.map((group) => {
      return (
        <p key={group.id}>
          {group.name}{' '}
          <a
            className="button smallest red margin-left"
            onClick={() => act.dashboard.removeGroup(group.id)}
          >
            Remove
          </a>
        </p>
      )
    })}
  </>
}

export default () => {
  const act = useAct()
  const { id, groups, scope } = useSel((s) => s.dashboard)

  return (
    <Step
      name="Users"
      editor="users"
      editable={true}
      complete
      shortDescriptor={<UsersShortDescriptor dashboardScope={scope} groups={groups} />}
      save={() => {}}
      showSave={false}
      showDiscard={false}
      showClose={true}
    >
      <div className="row">
        <div className="column half">
          <div className="field">
            <label>Who can view this Dashboard?</label>
            {groups.length === 0 && (
              <p>Currently no one can view this Dashboard. Add one or more user groups to grant access.</p>
            )}
            {groups.length > 0 && (
              <p>
                Users in <span className="bold">{scope}</span> or any sub-organisation,
                who belong to one of the following groups:
              </p>
            )}
            <div className='groups-list margin-top half'>
              <GroupsList groups={groups} />
            </div>
          </div>
          <div className="field">
            <label>Add a user group who can view the dashboard</label>
            <AsyncSelect
              entity="group"
              loadStaticList={true}
              getOptionLabel={(v) => v.name || v.label}
              queryParameters={{
                exclude: groups.map((g) => g.id),
              }}
              onChange={(_, group) => {
                act.dashboard.addGroup(group?.id || group?.value)
              }}
            />
          </div>
        </div>
      </div>
    </Step>
  )
}
